import React, { ReactNode } from 'react'
import { components, Options } from 'react-select'

import { MenuListProps } from '../Select.types'

const MenuList: React.FC<MenuListProps> = (props) => {
  const focusedOption = props.focusedOption
  let children
  if (props.focusedOption) {
    children = [...(props?.children as Array<ReactNode>)]
  } else {
    children = props.children
  }

  const options = [
    ...(props.options as Options<{ label: string; value: string; __isNew__: boolean }>),
  ]

  const hasOptionCreate = options[options.length - 1].__isNew__

  if (hasOptionCreate && focusedOption && !props.selectProps.inputValue) {
    children.pop()
    options.pop()
  }

  if (!focusedOption && !props.isCreatable && !children.length) {
    return (
      <components.MenuList {...props}>
        <components.NoOptionsMessage {...props}>No Data</components.NoOptionsMessage>
      </components.MenuList>
    )
  }

  return (
    <components.MenuList {...props} options={options}>
      {children}
    </components.MenuList>
  )
}

export default MenuList
